const $$splitComponentImporter = () => import('/src/src/routes/_authenticated/_feature_announcement/admin/manage/calendar/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { defineMessage } from "react-intl";
import { zodValidator } from "@tanstack/zod-adapter";
import { z } from "zod";
/**
 * @deprecated
 * @summary This whole manage/calendar directory is replaced by manage/events and should be
 * removed once the "events-guideline" feature flag is permanently on.
 */
export const Route = createFileRoute("/_authenticated/_feature_announcement/admin/manage/calendar/")({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  validateSearch: zodValidator(z.object({
    currentTab: z.number().int().optional().default(0),
    calendarDate: z.string().date().optional()
  })),
  staticData: {
    pageTitle: defineMessage({
      defaultMessage: "Calendar",
      description: "Page title"
    })
  }
});